import { Input } from '@angular/core';

export class Verb {
    private _node: any;
    @Input()
    set node(node: any) {
      this._node = node;
      this.setVariables();
    }
    get node(): any {
      return this._node;     
    }

    variables = []
    setVariables() {
      this.variables = [];
      if(this.node.context && this.node.context.imported){
        for(let key  in this.node.context.imported){
          if(this.node.context.imported[key].keys.indexOf(this.node.verb)!=-1 || this.node.context.imported[key].keys.indexOf("ALL")!=-1)
            this.variables = this.variables.concat(this.node.context.imported[key].variables);
        }
      }
    }
}
